import { ReactNode } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { cn } from '$components'
import { useTabsContext } from '../tabs'
import { tabStyling } from './styling'

export type TabProps = {
  to: string,
  children?: ReactNode,
  disabled?: boolean,
}

export function Tab({ to, children, disabled }: TabProps) {
  const { search } = useLocation()
  const { variant } = useTabsContext()

  return (
    <NavLink
      to={to + search}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault()
        }
      }}
      className={({ isActive }) => cn(
        tabStyling({ variant, isActive, isDisabled: disabled }),
      )}
    >
      {children}
    </NavLink>
  )
}
